import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
export function BlogPage() {
  return <>
      {/* Hero Section */}
      <Section className="py-20" background="offwhite" data-id="element-278">
        <div className="text-center mb-12" data-id="element-279">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-280">
            Blog & Updates
          </h1>
          <p className="text-xl font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-281">
            Stories, updates, and insights from our work delivering medical aid
            to Egypt.
          </p>
        </div>
      </Section>

      {/* Blog Posts */}
      <Section background="white" data-id="element-282">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-283">
          {[{
          title: 'Our First Shipment to Minya',
          date: 'December 15, 2023',
          excerpt: "Reflecting on our inaugural shipment of medical supplies to St. Mary's Monastery Clinic and the impact it's already making.",
          image: 'https://images.unsplash.com/photo-1584515933487-779824d29309?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
        }, {
          title: 'Why Coptic Communities Need Our Support',
          date: 'December 1, 2023',
          excerpt: "Understanding the healthcare challenges faced by Coptic Orthodox communities in Egypt and how we're working to address them.",
          image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
        }, {
          title: 'The Environmental Impact of Medical Waste',
          date: 'November 20, 2023',
          excerpt: 'How redirecting unused medical supplies helps both communities in need and our planet.',
          image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
        }].map((post, index) => <div key={index} className="bg-neutral-offwhite rounded-xl overflow-hidden shadow-md" data-id="element-284">
              <div className="h-48 overflow-hidden" data-id="element-285">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-286" />
              </div>
              <div className="p-6" data-id="element-287">
                <p className="font-inter text-sm text-primary-royal-blue mb-2" data-id="element-288">
                  {post.date}
                </p>
                <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-3" data-id="element-289">
                  {post.title}
                </h3>
                <p className="font-inter text-neutral-charcoal mb-4" data-id="element-290">
                  {post.excerpt}
                </p>
                <Button href="#" variant="tertiary" data-id="element-291">
                  Read More
                </Button>
              </div>
            </div>)}
        </div>
      </Section>

      {/* Newsletter CTA */}
      <Section background="sand" data-id="element-292">
        <div className="max-w-3xl mx-auto text-center" data-id="element-293">
          <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-294">
            Stay Updated
          </h2>
          <p className="text-lg font-inter text-neutral-charcoal mb-8" data-id="element-295">
            Subscribe to our newsletter for the latest stories and updates from
            the field.
          </p>
          <form className="flex flex-col sm:flex-row gap-4" data-id="element-296">
            <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" required data-id="element-297" />
            <Button type="submit" data-id="element-298">Subscribe</Button>
          </form>
        </div>
      </Section>
    </>;
}